import useSWR from 'swr';
import { apiBaseURL } from '../../Utils/ProjectConstants';
import useFetch from '../useFetch';
import { useNavigate } from 'react-router-dom';
import { getUserId } from '../../Utils/helper';
import handleBackendResponse from '../../Utils/handleNotifications/handleBackendResponse';

export default function useHandleHoursByUserId(userId) {

    const isCurrentUser = getUserId() === userId
    const navigate = useNavigate()
        , fetch = useFetch(navigate);

    const swrUrl = isCurrentUser ? `${apiBaseURL}/api/Hours/current` : `${apiBaseURL}/api/Hours/user?userId=${userId}&showDeleted=false`;
 
    const { data, error, mutate } = useSWR(swrUrl, {
        onSuccess: (data) => console.log('users hours fetched successfully:', data?.data),
        revalidateOnFocus: false,
        dedupingInterval: 300000,
    });

    const usersHours = data?.data?.map((x) => ({
        id: x.id,
        colorId: 1,
        locationId: x.locationId,
        taskId: x.taskId,
        projectId: x.projectId,
        type: (x.type === 0 ? "Research" : "Operation"),
        text: x.billing,
        startDate: new Date(x.startDate).toLocaleString(),
        endDate: new Date(x.endDate).toLocaleString(),
        allDay: true,
        hours: x.hours,
        description: x.remarks,
        comments: x.comments,
        isDeleted: x.isDeleted,
    })) || [];

    const isLoading = !data && !error;

    const handlePostHours = async (formData, billingAndWorkArr, taskArr, billingType) => {
        const startDate = new Date(formData.startDate).toLocaleDateString('sv-SE');
        const selectedBCWO = billingAndWorkArr?.find((x) => x.id === formData.billingAndWorkId);
        const taskId = taskArr?.length === 1 ? taskArr[0].id : formData.taskId;

        let body = {
            billing: formData.billingAndWorkId,
            code: selectedBCWO?.code,
            hours: formData.totalHours,
            locationId: formData.locationId,
            projectId: selectedBCWO?.projectId,
            remarks: formData.description,
            startDate: startDate,
            taskId: taskId,
            type: billingType,
        }

        if (!isCurrentUser) {
            body = {
                ...body,
                userId: formData.userId
            }
        }

        const uploadUrl = isCurrentUser ? '/api/Hours/Engineering' : '/api/Hours/Engineering/User';
        const response = await fetch.post(`${apiBaseURL + uploadUrl}`, body);
        const isDataGood = handleBackendResponse(response);

        if (isDataGood) await mutate();

        return isDataGood;
    }

    const handlePutHours = async (formData, billingAndWorkArr, taskArr, billingType) => {
        const startDate = new Date(formData.startDate).toLocaleDateString('sv-SE');
        const selectedBCWO = billingAndWorkArr?.find((x) => x.id === formData.billingAndWorkId);
        const taskId = taskArr?.length === 1 ? taskArr[0].id : formData.taskId;

        const body = {
            id: formData.id,
            startDate: startDate,
            hours: formData.totalHours,
            billing: formData.billingAndWorkId,
            locationId: formData.locationId,
            code: selectedBCWO?.code,
            type: billingType,
            remarks: formData?.description,
            taskId,
            projectId: selectedBCWO?.projectId
        }
        const uploadUrl = isCurrentUser ? '/api/Hours/User/Current' : '/api/Hours/User';
        const response = await fetch.put(`${apiBaseURL + uploadUrl}`, body);
        const isDataGood = handleBackendResponse(response);

        if (isDataGood) await mutate();

        return isDataGood;
    }

    const handlePasteHours = async (hoursData, billingAndWorkArr, rawStartDate, userId) => {
        const selectedBCWO = billingAndWorkArr?.find((x) => x.id === hoursData.text);
        const startDate = new Date(rawStartDate).toISOString().split('T')[0];

        let body = {
            billing: hoursData.text,
            code: selectedBCWO?.code,
            hours: hoursData.hours,
            locationId: hoursData.locationId,
            projectId: hoursData.projectId,
            remarks: hoursData.description,
            startDate,
            taskId: hoursData.taskId,
            type: hoursData.type,
        }
        if (!isCurrentUser) {
            body = {
                ...body,
                userId,
            }
        }

        const uploadUrl = isCurrentUser ? '/api/Hours/Engineering' : '/api/Hours/Engineering/User';
        const response = await fetch.post(`${apiBaseURL + uploadUrl}`, body);
        const isDataGood = handleBackendResponse(response);

        if (isDataGood) await mutate();

        return isDataGood;
    }

    const handleDelHours = async (id) => {
        const response = await fetch.delete(`${apiBaseURL}/api/Hours/User?id=${id}`);
        const isDataGood = handleBackendResponse(response);

        if (isDataGood) await mutate();

        return isDataGood
    }

    return {
        usersHours,
        error,
        mutate,
        isLoading,
        handleDelHours,
        handlePostHours,
        handlePutHours,
        handlePasteHours,
    }
}